<script lang="ts">
    export let size = 26;
    export let color = '#0F0F0F';
</script>

<svg width={size} height={size} viewBox="0 0 26 26" fill="none">
    <path
        d="M17.877 10.0854L11.7062 17.4394L8.02919 14.354"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
